"use client";
import { Box, Table } from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { TABLE_DATA } from "./constants";

const MigrationTable = () => {
  const HeadingVariant = useHeadingVariant();
  const { heading, tableHeading, tableData } = TABLE_DATA;
  return (
    <Box>
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        {heading}
      </Heading>
      <Table.Root striped border={"2px solid rgb(237,242,247)"}>
        <Table.Header>
          <Table.Row>
            {tableHeading.map((head, index) => {
              return (
                <Table.ColumnHeader key={index} textAlign={"center"} fontWeight={700}>
                  {head}
                </Table.ColumnHeader>
              );
            })}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {tableData.map((data, index) => {
            return (
              <Table.Row key={index} justifyItems={"center"}>
                <Table.Cell textAlign={"center"} fontWeight={600}>
                  {data.From}
                </Table.Cell>
                <Table.Cell textAlign={"center"}>{data.Target_in_MOST}</Table.Cell>
                <Table.Cell textAlign={"center"}>{data.Tools_Used}</Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Box>
  );
};

export default MigrationTable;
